import { RemoteGetAllEntitiesSummary } from 'data/usecases/entities/remote-get-all-entities-summary';
import { makeApiUrlEntitiesSummary } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllEntitiesSummary = (): RemoteGetAllEntitiesSummary =>
  new RemoteGetAllEntitiesSummary(
    makeApiUrlEntitiesSummary(),
    makeAxiosHttpClient(),
  );
